const setupUsersEditListeners = () => {
  const user_create_password = document.getElementById("user_create_password")

  if (user_create_password) {
    const link = document.getElementById("video_private_link")

    user_create_password.addEventListener("change", (event) => {
      if (event.target.checked) {
        link.style.display = "block";
      } else {
        link.style.display = "none";
      }
    });
  }
};

export { setupUsersEditListeners }